export const moduleName = 'vendorInfo'
